import { NgModule } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
//pipes
import { SafePipe } from './pipes/safe.pipe';
import { LimitPipe } from './pipes/limit.pipe';
import { SplitPipe } from './pipes/split.pipe';
import { SpecialCharPipe } from './pipes/special-char.pipe';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { InArrayPipe } from './pipes/in-array.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { PromoFilterPipe } from './pipes/promoFilter.pipe';
import { pictureSrcsetPipe } from './pipes/picture-srcset.pipe';
import { ArraySortPipe } from './pipes/sort.pipe';
//directives
import { ToggleShowHidePassDirective } from './directives/toggle-show-hide-pass.directive';
import { OrdinalDatePipe } from './pipes/ordinal-date.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

@NgModule({
    declarations: [
        //pipes
        SafePipe, LimitPipe, SplitPipe, SpecialCharPipe, CustomCurrencyPipe, InArrayPipe, FilterPipe, PromoFilterPipe, pictureSrcsetPipe, ArraySortPipe,OrdinalDatePipe,
        //directives
        ToggleShowHidePassDirective, SafeHtmlPipe
    ],
    exports: [
        //pipes
        SafePipe, LimitPipe, SplitPipe, SpecialCharPipe, CustomCurrencyPipe, InArrayPipe, FilterPipe, PromoFilterPipe, pictureSrcsetPipe, ArraySortPipe,OrdinalDatePipe,
        //directives
        ToggleShowHidePassDirective, SafeHtmlPipe
    ],
    providers: [CurrencyPipe]
})

export class helpersModule {

}